import {Component, EventEmitter, Input, Output} from '@angular/core';
import {Personne} from '../../../../interface/api/Personne';

import { FormsModule } from '@angular/forms';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/core';

@Component({
    selector: 'app-directeur',
    templateUrl: './directeur.component.html',
    styleUrls: ['./directeur.component.scss'],
    imports: [FormsModule, MatSelect, MatOption]
})
export class DirecteurComponent {
    _directeur: Personne = null;
    _mode: string = null;

    @Output() receveDirecteur = new EventEmitter();

    @Input()
    set directeur(directeur: Personne) {
        this._directeur =
            directeur != undefined && directeur != null
                ? directeur
                : { titre: '', civilite: '', nom: '', prenom: '' };
    }

    @Input()
    set mode(mode) {
        this._mode = mode != undefined && mode != null ? mode : 'visualisation';
    }

    public compareByValue(itemOne, itemTwo) {
        return itemOne == itemTwo;
    }

    emitDirecteur($event) {
        this.receveDirecteur.emit(this._directeur);
    }
}
